// Shared country list + address helpers for US + international shipping.
export const COUNTRIES = [
  { code: "US", name: "United States" },
  { code: "CA", name: "Canada" },
  { code: "GB", name: "United Kingdom" },
  { code: "AU", name: "Australia" },
  { code: "AE", name: "United Arab Emirates" },
  { code: "SA", name: "Saudi Arabia" },
  { code: "QA", name: "Qatar" },
  { code: "KW", name: "Kuwait" },
  { code: "BH", name: "Bahrain" },
  { code: "OM", name: "Oman" },
  { code: "JO", name: "Jordan" },
  { code: "LB", name: "Lebanon" },
  { code: "EG", name: "Egypt" },
  { code: "MA", name: "Morocco" },
  { code: "DZ", name: "Algeria" },
  { code: "TN", name: "Tunisia" },
  { code: "TR", name: "Türkiye" },
  { code: "PK", name: "Pakistan" },
  { code: "IN", name: "India" },
  { code: "BD", name: "Bangladesh" },
  { code: "ID", name: "Indonesia" },
  { code: "MY", name: "Malaysia" },
  { code: "SG", name: "Singapore" },
  { code: "NG", name: "Nigeria" },
  { code: "ZA", name: "South Africa" },
  { code: "KE", name: "Kenya" },
  { code: "FR", name: "France" },
  { code: "DE", name: "Germany" },
  { code: "NL", name: "Netherlands" },
  { code: "BE", name: "Belgium" },
  { code: "ES", name: "Spain" },
  { code: "IT", name: "Italy" },
  { code: "SE", name: "Sweden" },
  { code: "NO", name: "Norway" },
  { code: "IE", name: "Ireland" },
  { code: "NZ", name: "New Zealand" },
  { code: "JP", name: "Japan" },
  { code: "OTHER", name: "Other country" },
];

export const isUS = (code) => String(code || "US").trim().toUpperCase() === "US";

export const countryName = (code) =>
  (COUNTRIES.find((c) => c.code === String(code || "").toUpperCase()) || {}).name || code || "United States";

export const regionLabel = (code) => (isUS(code) ? "State" : "State / Province / Region");
export const postalLabel = (code) => (isUS(code) ? "ZIP" : "Postal code");

// Countries Stripe supports as connected-account (payout) countries. Excludes shipping-only
// entries: Lebanon (not a Stripe country), India (US platforms can't create IN accounts), and "Other".
export const PAYOUT_COUNTRIES = COUNTRIES.filter((c) => !["OTHER", "LB", "IN"].includes(c.code));
